import { PlanLimitConfigs, BillingCycleConfig } from '../types.js';

export const TALENT_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const TALENT_DEFAULT_UNIT_COUNT = 100;

export const TALENT_MIN_ENTERPRISE_USER_COUNT = Infinity;

export const talentOfferingSkus = {
	free: 'talent-free-sku',
	business: 'talent-business-sku',
	businessPlusAi: 'talent-business-ai-sku',
	enterprise: 'talent-enterprise-sku',
} as const;

export const talentOfferingSkusArray = Object.values(talentOfferingSkus);

export const talentPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Free',
		offeringSku: talentOfferingSkus.free,
		recommendationLimit: Infinity,
		signupLimit: 50_000,
	},
	{
		planName: 'Business',
		offeringSku: talentOfferingSkus.business,
		recommendationLimit: Infinity,
		signupLimit: 50_000,
	},
	{
		planName: 'Business + AI',
		offeringSku: talentOfferingSkus.businessPlusAi,
		recommendationLimit: 0,
		signupLimit: 50_000,
	},
	{
		planName: 'Enterprise',
		offeringSku: talentOfferingSkus.enterprise,
		recommendationLimit: Infinity,
		signupLimit: 50_000,
	},
];

export const talentBillingCycleConfig: BillingCycleConfig = {
	monthly: true,
	annual: true,
};
